import { mdlCityListRequest } from "../models/service-models/city/CityListRequest";
import { mdlCityListResponse } from "../models/service-models/city/CityListResponse";
import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { GetResponse } from "../utils/ApiClient";

namespace CityService {
    export async function List(
        pRequest: mdlCityListRequest
    ): Promise<mdlServiceResponse<mdlCityListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlCityListResponse>>(
            "city/list",
            pRequest
        );
    }
}
export { CityService };